var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 47,
    viewBox: "0 0 48 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.4424 18.0752C30.4424 17.7669 30.3199 17.4712 30.1019 17.2532C29.8839 17.0352 29.5882 16.9127 29.2799 16.9127C28.9716 16.9127 28.6759 17.0352 28.4579 17.2532L24.0208 21.6903L19.5837 17.2532C19.3657 17.0352 19.07 16.9127 18.7617 16.9127C18.4534 16.9127 18.1577 17.0352 17.9397 17.2532C17.7217 17.4712 17.5992 17.7669 17.5992 18.0752C17.5992 18.3835 17.7217 18.6792 17.9397 18.8972L22.3768 23.3343L17.9397 27.7714C17.7217 27.9894 17.5992 28.2851 17.5992 28.5934C17.5992 28.9017 17.7217 29.1974 17.9397 29.4154C18.1577 29.6334 18.4534 29.7559 18.7617 29.7559C19.07 29.7559 19.3657 29.6334 19.5837 29.4154L24.0208 24.9783L28.4579 29.4154C28.6759 29.6334 28.9716 29.7559 29.2799 29.7559C29.5882 29.7559 29.8839 29.6334 30.1019 29.4154C30.3199 29.1974 30.4424 28.9017 30.4424 28.5934C30.4424 28.2851 30.3199 27.9894 30.1019 27.7714L25.6648 23.3343L30.1019 18.8972C30.3199 18.6792 30.4424 18.3835 30.4424 18.0752Z",
    fill: "#CB0B0B",
    stroke: "#CB0B0B",
    strokeWidth: 0.2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24.0208,
    y: 1.13137,
    width: 31.4,
    height: 31.4,
    rx: 15.7,
    transform: "rotate(45 24.0208 1.13137)",
    stroke: "#CB0B0B",
    strokeWidth: 1.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.e597ce908e35798df6ffea124ff62e0b.svg";
export { ForwardRef as ReactComponent };